import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PermissionDirective } from './permission.directive';
import { ShowFieldDirective } from './show-field.directives';
import { CustomFieldPermissionDirective } from './custom-field-permission.directive';

@NgModule({
  declarations: [PermissionDirective, ShowFieldDirective, CustomFieldPermissionDirective],
  imports: [CommonModule],
  exports: [PermissionDirective, ShowFieldDirective, CustomFieldPermissionDirective]
})
export class DirectivesModule {}
